module.exports = __webpack_public_path__ + "img/bot_event_info_day1.ba97866e.png";